import { Component } from 'react';
import { connect } from 'react-redux';
import { CaseStudy, SimulationEhr } from 'models/ui';
import { instructorSelectors } from 'redux/ducks/instructor';
import ContentInformationView from './ContentInformationView';
import { AssignmentType } from 'models/enum';

export enum Tabs {
  OVERVIEW = 0,
  CHARTS_INVOLVED = 1,
  PHASES = 2
}

export interface ContentInformationProps {
  // renamed to selectedContent and allow SimulationEhr as well
  selectedContent: CaseStudy | SimulationEhr;
  isBookOrganized?: boolean;
  assignmentType?: AssignmentType;
}
interface ContentInformationState {
  activeTab: number;
}

class ContentInformation extends Component<ContentInformationProps, ContentInformationState> {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: Tabs.OVERVIEW
    };
  }

  handleTabGroupClick = (tabIndex) => this.setState({ activeTab: tabIndex });

  render() {
    const { activeTab } = this.state;
    const { selectedContent, assignmentType } = this.props;

    return (
      <ContentInformationView
        activeTab={activeTab}
        selectedContent={selectedContent}
        onTabGroupClick={this.handleTabGroupClick}
        isBookOrganized={this.props.isBookOrganized}
        assignmentType={assignmentType}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isBookOrganized: instructorSelectors.getIsBookOrganized(state)
});

export { ContentInformation as BaseContentInformation };
export default connect(mapStateToProps)(ContentInformation);
